import { useQuery } from '@tanstack/react-query';
import { Activity } from 'lucide-react';
import { Badge } from '@/components/ui/badge';
import { api } from '@/lib/api';

const VARIANT = {
  ok: 'success',
  degraded: 'warning',
  down: 'destructive',
  unknown: 'muted',
} as const;
const LABEL = { ok: 'Ready', degraded: 'Attention', down: 'Down', unknown: 'Unknown' } as const;

/** App readiness badge in the top bar (UI_DESIGN.md). Text + color, never color alone. */
export function ReadinessBadge() {
  const { data, isLoading, isError } = useQuery({
    queryKey: ['readiness'],
    queryFn: api.readiness,
    refetchInterval: 30_000,
  });

  if (isLoading) {
    return (
      <Badge variant="muted" aria-live="polite">
        <Activity className="size-3" /> Checking…
      </Badge>
    );
  }
  if (isError || !data) {
    return (
      <Badge variant="destructive">
        <Activity className="size-3" /> Unavailable
      </Badge>
    );
  }
  return (
    <Badge variant={VARIANT[data.status]} title={`Send mode: ${data.sendMode}`}>
      <Activity className="size-3" /> {LABEL[data.status]}
    </Badge>
  );
}
